import React from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Plus, X, CornerDownRight, Shield } from 'lucide-react';

const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));
export const newCompetencePro = () => ({ id: uid(), titre: '', sous_competences: [] });

// Éditeur des compétences professionnelles à valider (avec sous-compétences informatives)
export const CompetencesProEditor = ({ value = [], onChange }) => {
  const upd = (i, patch) => onChange(value.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const updSub = (i, k, v) => upd(i, { sous_competences: value[i].sous_competences.map((s, j) => (j === k ? v : s)) });
  return (
    <div className="space-y-2" data-testid="competences-pro-editor">
      {value.map((c, i) => (
        <div key={c.id} className="rounded-lg border border-slate-200 bg-slate-50/50 p-2.5 space-y-1.5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-indigo-600 w-6">C{i + 1}</span>
            <Input value={c.titre} onChange={(e) => upd(i, { titre: e.target.value })} placeholder="Compétence professionnelle à valider" className="h-8 text-sm" data-testid={`cp-titre-${i}`} />
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="p-1 rounded text-slate-400 hover:text-red-600 hover:bg-red-50" data-testid={`cp-remove-${i}`}><X className="w-4 h-4" /></button>
          </div>
          {c.sous_competences.map((s, k) => (
            <div key={k} className="flex items-center gap-2 pl-8">
              <CornerDownRight className="w-3.5 h-3.5 text-slate-400 shrink-0" />
              <Input value={s} onChange={(e) => updSub(i, k, e.target.value)} placeholder="Sous-compétence (information, non évaluée)" className="h-7 text-xs" data-testid={`cp-sub-${i}-${k}`} />
              <button type="button" onClick={() => upd(i, { sous_competences: c.sous_competences.filter((_, j) => j !== k) })} className="p-1 rounded text-slate-400 hover:text-red-600" data-testid={`cp-sub-remove-${i}-${k}`}><X className="w-3.5 h-3.5" /></button>
            </div>
          ))}
          <button type="button" onClick={() => upd(i, { sous_competences: [...c.sous_competences, ''] })} className="pl-8 text-[11px] text-indigo-600 hover:underline" data-testid={`cp-add-sub-${i}`}>+ Ajouter une sous-compétence</button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...value, newCompetencePro()])} data-testid="cp-add"><Plus className="w-3.5 h-3.5 mr-1" /> Ajouter une compétence professionnelle</Button>
      <p className="text-[11px] text-slate-400">Ces compétences sont validées (atteinte / non atteinte) dans le bilan de formation. Les sous-compétences sont informatives.</p>
    </div>
  );
};

// Affichage lecture seule
export const CompetencesProList = ({ competences = [], legacyText, className = '' }) => {
  const list = competences.filter(c => (c.titre || '').trim());
  if (!list.length) return legacyText ? <p className={`text-sm text-slate-700 whitespace-pre-wrap ${className}`}>{legacyText}</p> : null;
  return (
    <ul className={`space-y-1.5 ${className}`} data-testid="competences-pro-list">
      {list.map((c, i) => (
        <li key={c.id || i} className="text-sm">
          <p className="flex items-start gap-1.5 text-slate-800 font-medium"><Shield className="w-3.5 h-3.5 text-indigo-500 mt-0.5 shrink-0" /> {c.titre}</p>
          {c.sous_competences?.filter(Boolean).length > 0 && <ul className="pl-6 mt-0.5 space-y-0.5">{c.sous_competences.filter(Boolean).map((s, k) => <li key={k} className="text-xs text-slate-500">– {s}</li>)}</ul>}
        </li>
      ))}
    </ul>
  );
};
